import * as React from "react";

export const IconSave = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.6667 0L1.66667 0C0.741667 0 0 0.75 0 1.66667L0 13.3333C0 14.25 0.741667 15 1.66667 15L13.3333 15C14.25 15 15 14.25 15 13.3333L15 3.33333L11.6667 0ZM7.5 13.3333C6.11667 13.3333 5 12.2167 5 10.8333C5 9.45 6.11667 8.33333 7.5 8.33333C8.88333 8.33333 10 9.45 10 10.8333C10 12.2167 8.88333 13.3333 7.5 13.3333ZM10 5L1.66667 5L1.66667 1.66667L10 1.66667V5Z"
      fill="white"
    />
  </svg>
);
